"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//dont touch unless you're sure you have to
const platform_browser_dynamic_1 = require("@angular/platform-browser-dynamic");
const app_module_1 = require("./app.module");
const platform = (0, platform_browser_dynamic_1.platformBrowserDynamic)();
platform.bootstrapModule(app_module_1.AppModule);
//# sourceMappingURL=main.js.map